/**
  * PNP-Aufgabe: Zuordnung von Elementen zu Körben
  * @namespace v3sWbtPlayerApp:exercise:pnp
  */
/**
 * Ermöglicht die Darstellung von Source-Elementen einer Pick And Place Aufgabe
 * Erstellt v3s-source-item Direktiven
 * @class directive_v3sSource
 * @memberOf v3sWbtPlayerApp:exercise:pnp
 */
angular.module('v3sWbtPlayerApp').directive('v3sSource', ['$compile', '$document', function ($compile, $document) {
    return {
        restrict: 'E',
        transclude: true,
        require: ['^v3sDocument', '^v3sExercise'],
        controller: ['$scope', '$element', function ($scope, $element) {
            this.shrinkIfEmpty = function () {
                if ($element.children().length == 0) {
                    $element.css({
                        "width": 0,
                        "height": 0
                    });
                }
            }
        }],
        link: function (scope, element, attrs, controllers, transclude) {

            var v3sDocumentCtrl = controllers[0];
            var exCtrl = controllers[1]

            scope.getVar = v3sDocumentCtrl.getVar;

            if (!!scope.id) {
                v3sDocumentCtrl.addElement(element);
            }
            var copies = null; //mindestens eins wird gemacht
            var fod, data, targetids;


            /**
             * Per Transclude werden die Daten für die v3s-source-item direktiven ausgelesen
             */
            transclude(scope, function (clone, scope) {
                angular.forEach(clone, function (node) {
                    var tagName = node.tagName.toLowerCase();
                    var innerText = node.textContent;
                    if (!!innerText) {
                        if (tagName == "v3s-targetid") {
                            targetids = node;
                        } else if (tagName == "v3s-fod") {
                            fod = node;
                        } else if (tagName == "v3s-data") {
                            var ngNode = angular.element(node);
                            if (attrs.v3sWidth != 0) {
                                ngNode.css('width', attrs.v3sWidth + "px");
                            }
                            if (attrs.v3sHeight != 0) {
                                ngNode.css('height', attrs.v3sHeight + "px");
                            }
                            data = ngNode;
                        } else if (tagName == "v3s-copies") {
                            if(parseInt(innerText) > 0){
                                copies = parseInt(innerText);
                            }
                        }
                        
                    }
                })
            })

            //Wurde die Anzahl der Kopien angegeben? Oder soll die Anzahl automatisch berrechnet werden
            var sourceItemCount;
            if (!!copies) {
                sourceItemCount = copies;
            } else {
                var targets = (!!targetids) ? (targetids.innerHTML.split(',').length) - 1 : 1;
                sourceItemCount = targets;
            }

            //Erstelle die v3s-source-item direktiven
            for (var i = 0; i < sourceItemCount; i++) {
                var sourceItem = angular.element('<v3s-source-item id="' + attrs.id + '-' + i + '" v3s-source-id="' + attrs.id + '" v3s-left="' + attrs.v3sLeft + '" v3s-top="' + attrs.v3sTop + '" class="offTarget"></v3s-source-item>');
                sourceItem.append(fod);
                sourceItem.append(data);
                sourceItem.append(targetids);
                if (!!attrs.v3sFile) sourceItem.attr('v3s-file', attrs.v3sFile);
                if (!!attrs.v3sBorderWidth) sourceItem.attr('v3s-border-width', attrs.v3sBorderWidth);
                if (!!attrs.v3sBorderColor) sourceItem.attr('v3s-border-color', attrs.v3sBorderColor);
                if (!!attrs.v3sBackgroundColor) sourceItem.attr('v3s-background-color', attrs.v3sBackgroundColor);
                if (!!attrs.v3sBorder) sourceItem.attr('v3s-border', attrs.v3sBorder);
                

                if (attrs.v3sWidth != 0) sourceItem.attr('v3s-width', attrs.v3sWidth);
                if (attrs.v3sHeight != 0) sourceItem.attr('v3s-height', attrs.v3sHeight);

                //Margin setzen, falls abstand gewünscht
                if (!!attrs.v3sBorder && attrs.v3sBorder > 0) sourceItem.css('margin', attrs.v3sBorder + "px");

                element.append(sourceItem);
                $compile(sourceItem)(scope);
                v3sDocumentCtrl.addElement(sourceItem);
                //Die Größe setzen, wenn alles gerendert ist, damit die Kopien nicht herausragen
                $document.ready(function () {
                    var anysourceitem = element.find("v3s-source-item")[0];
                    if (!!anysourceitem) {
                        var w = anysourceitem.offsetWidth;
                        var h = anysourceitem.offsetHeight;
                        if (!!attrs.v3sBorderWidth && attrs.v3sWidth == "0" && attrs.v3sHeight == "0") {
                            element.css("padding", attrs.v3sBorderWidth + "px");
                        }
                        element.css('width', w + "px");
                        element.css('height', h + "px");
                    }
                })
            }
        }
    }
}]);

/**
 * Das verschiebare Element der Pick and Place Aufgaben
 * @class directive_v3sSourceItem
 * @memberOf v3sWbtPlayerApp:exercise:pnp
 */
angular.module('v3sWbtPlayerApp').directive('v3sSourceItem', ['v3sSourceElement', '$tooltip', '$document', '$timeout', '$interval', '$q', 'v3sI18nService', 'v3sContentMediaPath', 'v3sGeometricsService', 'v3sGsapService', function (v3sSourceElement, $tooltip, $document, $timeout, $interval, $q, v3sI18nService, v3sContentMediaPath, v3sGeometricsService, v3sGsapService) {
    return {
        restrict: 'E',
        require : ['^v3sExercise', '^v3sSource'],
        transclude : true,
        link: function (scope, element, attrs, controllers, transclude) {
            var exCtrl = controllers[0];
            var sourceCtrl = controllers[1];
            //Die möglichen Targets
            var targets = exCtrl.getTargets();
            //Das sourceelement
            var sourceElement = new v3sSourceElement(attrs.id,attrs.v3sSourceId, element, targets);
           
            //Wurde der Status geladen?
            var fod, tooltip;
            var recreateState = function () {
                /**
                 * Wenn das Feedback gezeigt wird, sollen nur die bereits korrekten beantworteten
                 * Element zugeordnet werden, ansonsten blockieren die falsch zugeordneten antowrten
                 * evtl. die Auswertung
                 */
                var deferred = $q.defer();
                if (!!sourceElement.userAnswer && (sourceElement.isFeedbackVisible() && !sourceElement.completed || sourceElement.status == sourceElement.STATUS.CORRECT)) {
                    var t = getTargetWithPromise(sourceElement.userAnswer.id);
                    t.then(function (t) {
                        $timeout(function () {
                            t.addSource(sourceElement);
                            t.appendElement(element);
                            element.addClass('onTarget');
                            element.removeClass('offTarget');
                            TweenLite.to(element, { 'position': 'static', 'display': 'inline-block', 'z-index' : 0 });
                            deferred.resolve({ stateLoaded: true });
                        });
                    });
                } else {
                    deferred.resolve({ stateLoaded: false });
                }
                return deferred.promise;
            }
            var getTargetWithPromise = function (id) {
                var t = null;
                var deferred = $q.defer();
                var stopMe = $interval(function () {
                    t = exCtrl.getTargetById(id);
                    if (!!t) {
                        deferred.resolve(t);
                        if (angular.isDefined(stopMe)) {
                            $interval.cancel(stopMe);
                            stopMe = undefined;
                        }
                        return t;
                    } else {
                        deferred.reject({showSolution : false});
                    }
                }, 300);
                return deferred.promise;
            }

            //Den alten Stand wiederherstellen und dann showSolution aufrufen
            recreateState().then(function (res) {
                sourceElement.setShowFeedback(showFeedback);
            });

            exCtrl.addSourceElement(sourceElement);
            
            transclude(scope, function (clone, scope) {
                angular.forEach(clone, function (node) {
                    var tagName = node.tagName.toLowerCase();
                    var innerText = node.textContent;
                    if (!!innerText) {
                        if (tagName == "v3s-targetid") {
                            sourceElement.setTargets(innerText);
                        } else if (tagName == "v3s-fod") {
                            fod = innerText;
                        } else if (tagName == "v3s-data") {
                            var ngNode = angular.element(node);
                            ngNode.css('width', attrs.v3sWidth + "px");
                            ngNode.css('height', attrs.v3sHeight + "px");
                            element.append(node);
                        }
                        
                    }
                });
            })

            var showFeedback = function () {
                if (sourceElement.isFeedbackVisible()) {

                    if (!!tooltip) {
                        tooltip.hide();
                        tooltip.setEnabled(false);
                    }
                    var status = sourceElement.getStatus();
                    var msg = v3sI18nService.getText([
                        "exercises.fod.pnp." + status.name,
                        "exercises.fod.general." + status.name
                    ]);
                    if (sourceElement.completed) {
                        if (!!fod) {
                            msg += " " + fod;
                        }
                    }
                    if (status === sourceElement.STATUS.CORRECT) {
                        element.addClass('correct');
                        pnpDraggable[0].disable();
                    } else {
                        //Die SourceElemente sind completed
                        //Aber nicht korrekt gelöst
                        if (sourceElement.completed) {
                            TweenLite.set(element, {
                                position: 'absolute',
                                className: 'offTarget'
                            });
                            exCtrl.appendElement(element);
                            if (status === sourceElement.STATUS.FALSE) {
                                element.addClass('wrong');
                            } else {
                                element.addClass('correct silent');
                            }

                            if (!!sourceElement.userAnswer) {
                                var t = getTargetWithPromise(sourceElement.userAnswer.id);
                                t.then(function (t) {
                                    t.removeSource(sourceElement);
                                })
                            }

                            //Animiere die Elemente auf ihre Ausgangs position
                            TweenLite.to(element, 0.7, {
                                left: element.attr('v3s-left'),
                                top: element.attr('v3s-top'),
                                // Alle Elemente sind herausgeflogen
                                onComplete: function () {
                                    var possibleTargetIds = sourceElement.targetids;
                                    var theTarget = null;

                                    //Alle möglichen Ziele testen, ob sie eventuelle schon eine Kopie enthalten
                                    angular.forEach(possibleTargetIds, function (tid, $index) {
                                        if (!!theTarget) return;
                                        var foundTarget = exCtrl.getTargetById(tid);
                                        //Es wurde ein Ziel gefunden
                                        $timeout(function () { }, 1000);
                                        if (!!foundTarget) {
                                            //Das gefundene Target enthält keine Kopie oder lässt nur das Original element zu
                                            //-> Source kann dem Target zugeordnet werden
                                            if (!foundTarget.containsCopies(sourceElement)) {
                                                if (!foundTarget.hasLogicalSpace()) {
                                                    sourceElement.blocked = true;
                                                } else {
                                                    theTarget = foundTarget;
                                                    theTarget.addSource(sourceElement);
                                                    element.removeClass("offTarget");
                                                }
                                            } else {
                                                /**
                                                 * Alle möglichen Targets wurden getestet und es kann nicht korrekt zu geordnet werden
                                                 * -> es ist geblockt
                                                 */
                                                if ($index == possibleTargetIds.length) {
                                                    element.addClass('correct');
                                                    sourceElement.blocked = true;
                                                }

                                            }
                                        }
                                    });
                                    //Es wurde ein Target gefunden
                                    //Source wird zugeordnet
                                    if (!!theTarget) {
                                        TweenLite.to(element, 0.7, {
                                            left: theTarget.element.attr('v3s-left'),
                                            top: theTarget.element.attr('v3s-top'),
                                            onComplete: function () {
                                                element.removeClass('wrong');
                                                element.removeClass("offTarget");
                                                theTarget.appendElement(element);
                                                TweenLite.set(element, { 'position': 'static', 'display': 'inline-block', 'z-index': 0 });

                                            }

                                        })
                                    }
                                }
                            });
                        }
                    }

                    if (sourceElement.completed) {
                        tooltip = $tooltip(element, { title: msg, container: "v3s-document", viewport: '#page-view', trigger: 'hover focus' });
                    }
                }
                if (sourceElement.completed) {
                    pnpDraggable[0].disable();
                }
            }
            //Hintergrundgrafik setzen
            if (!!attrs.v3sFile) {
                element.css({
                    'background-image': 'url(./' + v3sContentMediaPath + attrs.v3sFile + ')'
                })
            }

            //Das GSAP-Draggable-Element
            var pnpDraggable;
            pnpDraggable = v3sGsapService.createDraggable(element, {
                type: "top,left",
                onPress : onPress, 
                onRelease: onRelease
            });

            //Der Press-EventHandler
            function onPress(evt) {
                /**
                 * Wenn das Element in einem Target war, müssen wir die Top-Position anpassen,
                 * da diese noch vom drag and drop vorhanden ist
                 * Außerdem muss das SourceElement aus dem Target entfernt werden
                 */
                if (element.hasClass('onTarget')) {
                    TweenLite.set(element, { top: pnpDraggable[0].pointerY - v3sGeometricsService.getOffset($document.find('v3s-document')).top - (element[0].offsetHeight /2)});
                    TweenLite.set(element, { left: pnpDraggable[0].pointerX - v3sGeometricsService.getOffset($document.find('v3s-document')).left - (element[0].offsetWidth /2)});
                    this.update();
                }
                TweenLite.set(element, { 'position': 'absolute' ,  'display': 'block' });
                //Element dem ExerciseElement anhängen
                exCtrl.appendElement(element);
                if (!!sourceElement.userAnswer) sourceElement.userAnswer.removeSource(sourceElement);
                evt.stopPropagation();
            }

            //Der Release-EventHandler
            function onRelease(evt) {
                var targetfound = false;
                var self = this;
                self.startX = attrs.v3sLeft;
                self.startY = attrs.v3sTop;
                //Hittest für alle möglichen Targets
                angular.forEach(targets, function (t) {
                    var targetElement = t.element[0];
                    if (!targetfound && targetElement.style.visibility !== "hidden") {
                        if (self.hitTest(targetElement, "55%")) {
                            //Wenn es logischen oder physischen Platz hat, soll es zugeordnet werden
                            if ((t.hasLogicalSpace() || t.hasPhysicalSpace(element)) && !t.containsCopies(sourceElement)) {
                                targetfound = true;
                                t.addSource(sourceElement);
                                t.appendElement(element);
                                element.addClass('onTarget');
                                element.removeClass('offTarget');
                                TweenLite.set(element, { 'position': 'static', 'display': 'inline-block' });
                                sourceElement.setUserAnswer(t);
                                exCtrl.updateSourceStates()
                            }
                        } else {
                            
                        }
                    }
                })
                //Es wurde kein mögliches Target gefunden werden
                //-> Zurück auf die Startposition
                if (!targetfound) {
                    sourceElement.setUserAnswer(null);
                    exCtrl.updateSourceStates()
                    TweenLite.to(self.target, 0.5, {
                        top: self.startY,
                        left: self.startX,
                        clearProps: 'z-index'
                    });
                    element.removeClass('onTarget');
                    element.addClass('offTarget');

                }

                //Wenn die Source leer ist, soll sie schrumpfen ...
                sourceCtrl.shrinkIfEmpty();

            }
            
            

        }
    }

}]);

/**
 * Definiert das Model für die Auswertung eines Source-PNP-Elements
 * @class service_v3sSourceElement
 * @memberOf v3sWbtPlayerApp:exercise:pnp
 */
angular.module('v3sWbtPlayerApp').factory('v3sSourceElement', ['v3sExerciseService', 'v3sExerciseElement','$document', function (v3sExerciseService, v3sExerciseElement, $document) {
    /**
     * Konstruktor, registriert das Element beim {@link v3sWbtPlayerApp:exercise.service_v3sExerciseService} zur Auswertung
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sSourceElement
     * @constructor
     */
    var v3sSourceElement = function (id,sourceId,element, targets) {
        this.id = id;
        this.sourceId = sourceId;
        this.element = element;
        this.targetids = [];
        this.userAnswer = null;
        this.blocked = false //Kann nicht zugeordnet werden weil eine Kopie bereits im Target ist
        this.targets = targets //Die möglichen targets
        this.status = this.STATUS.SILENT_CORRECT;
        this.load();
    }

    v3sSourceElement.prototype = new v3sExerciseElement();


    /**
     * Setzt die möglichen Ziele für die Source
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sSourceElement
     * @param {string} targets - komma getrennter string mit den möglichen Targets
     */
    v3sSourceElement.prototype.setTargets = function (targets) {
        var self = this;
        angular.forEach(targets.split(','), function (t) {
            if (t !== "") self.targetids.push(t);
        })
        //Sobald Targets gefragt sind , ist der status noanswer
        if (self.userAnswer == null) {
            this.status = this.STATUS.NO_ANSWER;
        }
    }


    /**
     * Speichert die Zuordnung des Users 
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sSourceElement
     * @param {object} targets - das Target, dem die Source zugeordnet wurde
     */
    v3sSourceElement.prototype.setUserAnswer = function (target) {
        // Wenn schon eine Antwort gesetzt war, muss die Source aus dem angegebenen Target gelöscht werden
        if (!!this.userAnswer) {
            this.userAnswer.removeSource(this);
        }
        this.userAnswer = target;
        this.checkAnswer();
        this.save();
    }

    
    v3sSourceElement.prototype.hasCorrectAnswer = function () {
        if (this.status == this.STATUS.SILENT_CORRECT) {
            return false;
        } else {
            return true;
        }
    }
    /**
     * Wertet die Zuordung aus und setzt den entsprechenden Status
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sSourceElement
     */
    v3sSourceElement.prototype.checkAnswer = function () {
        var self = this;
        if (!!this.userAnswer) {
            if (self.isCorrectTarget()) {
                if (self.userAnswer.getCorrectSourcesCount() <= self.userAnswer.getLimit()) {
                    if (self.userAnswer.getCorrectSourcesCount() == self.userAnswer.getLimit()) {
                        if (self.blocked || self.status == this.STATUS.NO_ANSWER || self.status == this.STATUS.SILENT_CORRECT) {//Neu zugeordnet
                            self.status = this.STATUS.FALSE;//das neue ist zuviel
                        } else {
                            this.status = this.STATUS.CORRECT;
                        }
                    } else {
                            this.status = this.STATUS.CORRECT;
                    }
                } else {
                    this.status = this.STATUS.FALSE;
                }
            } else {
                this.status = this.STATUS.FALSE;
            }
        } else {
            if (this.targetids.length == 0) {
                this.status = this.STATUS.SILENT_CORRECT;
            } else {
                if (self.allTargetsContainCopy() || self.blocked || self.allTargetsHaveCorrectAmountOfCorrect()) {
                    self.blocked = true;
                    self.status = this.STATUS.SILENT_CORRECT;
                    v3sExerciseService.updateExercise(this, {});
                }else{
                    self.status = this.STATUS.NO_ANSWER;
                }
            }
        }

    }

    
    /**
     * Wertet aus, ob die Source einem korrekten Target zu geordnet wurde
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sSourceElement
     */
    v3sSourceElement.prototype.isCorrectTarget = function () {
        var self = this;
        var isCorrectTarget = false;
        if(!!this.userAnswer){
            angular.forEach(this.targetids, function (t) {
                if (self.userAnswer.id == t) {
                    isCorrectTarget = true;
                }
            });
        }
        return isCorrectTarget;
    }


    /**
     * Gibt die useranswer zurück
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sSourceElement
     */
    v3sSourceElement.prototype.getUserAnswer = function () {
        return this.userAnswer;
    }

    /**
     * Beinhaltet das gesuchte Target ein Copy dieser Source?
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sSourceElement
     * @param {string} targetid - Die ID des gesuchten Targets
     * @returns {boolean}
     */
    v3sSourceElement.prototype.targetContainsCopy = function(targetid){
        var self = this;
        var theTarget = document.getElementById(targetid);
        var hasCopy = false;
        if(!!theTarget){
            var ngTarget = angular.element(theTarget);
            var sources = ngTarget.find('v3s-source-item');
            angular.forEach(sources, function(s){
                if(angular.element(s).attr('v3s-source-id') == self.sourceId){
                    hasCopy = true;
                }
            });
        }
        return hasCopy;

    }

    /**
     * Durchsucht alle Targets der Aufgabe, ob sie alle eine Copy der Source enthalten
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sSourceElement
     * @returns {boolean}
     */
    v3sSourceElement.prototype.allTargetsContainCopy = function(){
        var self = this;
        var alliswell = true;
        angular.forEach(self.targetids, function(tid){
            if(!self.targetContainsCopy(tid)){
                alliswell = false;
            }
        });
        return alliswell;
    }

    /**
     * Prüft ob alle Targets bereits voll sind
     * @memberOf v3sWbtPlayerApp:exercise:pnp.service_v3sSourceElement
     * @returns {boolean}
     */
    v3sSourceElement.prototype.allTargetsHaveCorrectAmountOfCorrect = function () {
        var self = this;
        var allAreDone = true;
        angular.forEach(self.targetids, function (tid) {
            angular.forEach(self.targets, function (t) {
                if (t.id == tid) {
                    if (!t.hasAllCorrect()) {
                        allAreDone = false;
                    }
                }
            });

        });
        return allAreDone;
    }

    return v3sSourceElement;
}]);
